__webpack_require__.p = "/interactive/nar/competitive-real-estate-market/";